<template>
    <div class="remind-block">
        <div class="content" v-html="announcement"/>
<!--        <div class="list-style">-->
<!--            <div class="content">-->
<!--                <div class="detail">-->
<!--                    餐點可能加酒、香菜或蔥，若不需要請備註-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="right">-->
<!--                $ 0-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>

    export default {
        name: "Remind",
        props: ['announcement'],
        data() {
            return {

            }
        },
        created() {

        },
        mounted() {

        },
        methods: {

        }
    }
</script>

